/*
 * @Date: 2023-10-30 19:39:32
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-06-27 09:44:40
 * @FilePath: /Client/src/plugins/cache.ts
 * @Description:
 */
import dayjs from 'dayjs'
import { getCookie } from '@/plugins/utils'
import Cookie from 'js-cookie'
import { getQueryParams } from './tripartite-login'
import { useSite2Station } from '@/store'
let appid: string
// const version = '13'
const env = process.env.NODE_ENV === 'production' ? '.theckb.com' : 'localhost'

const caches = {
  init (val = 'production'): void {
    appid = val + '_'
    // if (localStorage.__VERSION !== version) {
    //   localStorage.clear()
    //   localStorage.__VERSION = version
    // }
  },
  set (k: string, val: any, expire: number | void): void {
    if (typeof val === 'function') {
      val = {
        $fn: true,
        val: val.toString(),
        expire: expire || null
      }
    } else {
      val = {
        val,
        expire: expire || null
      }
    }
    // if (k === 'route/token' && !val.val) debugger
    localStorage[appid + k] = JSON.stringify(val)
    const date = new Date()
    date.setTime(date.getTime() + (3 * 24 * 60 * 60 * 1000))
    document.cookie = `${appid + k}=${val.val ?? ''};path=/;expires=${date.toUTCString()}`
    console.log(Cookie.get(appid + k))
  },
  get (k: string): any {
    const { expire, val, $fn } = JSON.parse(localStorage[appid + k] || '{}')
    if (expire && dayjs(expire).isBefore(dayjs())) {
      // debugger
      this.delete(k)
    } else {
      if ($fn) {
      } else {
        return val
      }
    }
  },

  delete (k: string): void {
    delete localStorage[appid + k]
  },
  getAll (): any {
    const reg = new RegExp('^' + appid)
    return Object.keys(localStorage)
      .filter((k) => reg.test(k))
      .map((k) => [(k = k.replace(appid, '')), this.get(k)])
  }
}
export default caches

//
export const createProxy = (state: any, local:any, expire: number | void) => {
  return new Proxy(state, {
    get (target, key: string) {
      if (local[key]) {
        return caches.get(key) ?? target[key]
      } else {
        return target[key]
      }
    },
    set (target, key: string, val) {
      if (local[key]) {
        caches.set(key, val, expire)
      }
      target[key] = val
      return val
    }
  })
}
